import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import Cookies from "js-cookie";
import Service from '../../service/Service';
import * as actions from './actions';
import UploadImgOverlay from './common/UploadImgOverlay';
import withContext from "../../../withContext";
const service = new Service();

class RecipeUpload extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        let initialData = {};
        let isWindow = false;
        let isApp = '';
        if (this.props.location.search.includes('from=app')) {
            isApp = true;
        }
        this.state = {
            initialData: initialData,
            isWindow: isWindow,
            metaTitle: "Baby & Toddlers Meal Plans - FirstCry Parenting",
            uploadedSrc: '',
            uploadedVideoSrc: '',
            childData: global.ftk && global.userAry['childData']['UserChildList'],
            isMemorySelected: false,
            isFrame: false,
            isApp: isApp
        };
    }


    componentDidMount() {
        if(!global.ftk){
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/");
        }
        if (this.state.isApp) {
            actions.loadCallbackFile();
            if (window.innerWidth <= 767) {
                if (window.innerHeight == 812 || window.innerHeight == 823) {
                    document.querySelector('.snackbar').style.bottom = "30%";
                } else if (window.innerHeight == 667) {
                    document.querySelector('.snackbar').style.bottom = "15%";
                } else if (window.innerHeight == 736 || window.innerHeight == 731) {
                    document.querySelector('.snackbar').style.bottom = "23%";
                }else{
                    document.querySelector('.snackbar').style.bottom = "0";
                }
            }
            document.querySelector('.memories-main').style.background = "#eee";
            

        }
    }
    closeuploadpopup() {
        document.getElementsByClassName('uploadImg-overlay')[0].style.display = 'none';
    }
    uploadRecipe() {
        document.getElementsByClassName('uploadImg-overlay')[0].style.display = 'block';
    }
    render() {
        return (
            <main className="memories-main main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                />
                {!this.state.isApp && 
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={global.redirect_url+"tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                        <span>{this.state.recipeName}</span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Recipe Upload</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Upload Recipe</h1>
                </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                        <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Upload Recipe</span>
                    </div>
                }
                <div className="sub-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container left">
                        <div className="memories_container recipe-upload-con">
                            <div className="memory-upload-wrap">
                                <div className="div-upload-memory">
                                    {this.state.isApp ?
                                        <div className="uploaded-img" style={this.state.uploadedSrc ? { height: 'auto' } : {}}>
                                            <img id="memoryimg" className="memoryimg" src={this.state.uploadedSrc && this.state.uploadedSrc.replace("http://", "https://")} />
                                        </div>
                                        :
                                        <div className="uploaded-img" style={this.state.uploadedSrc ? { height: 'auto' } : {}}>
                                            {this.state.uploadedSrc && this.state.uploadedSrc != '' &&
                                                <img id="memoryimg" className="memoryimg" src={this.state.uploadedSrc.replace("http://", "https://")} />
                                            }
                                        </div>
                                    }
                                    <div className="file_upload_err"></div>
                                </div>
                                <div className="snackbar m-upload-btn">
                                    {this.state.isApp &&
                                        <div className="askquebtn uploadphoto_App" style={{ display: "none" }} onClick={(e) => actions.uploadMemory(this, this.state.isApp)}>
                                            <div data-icon-font="" className="icon"></div>
                                            <span className="ask-quen M14_white">UPLOAD YOUR RECIPE</span>
                                        </div>}
                                    {this.state.isMemorySelected ?
                                            <div className="askquebtn uploadphoto_App" onClick={(e) => actions.uploadMemory(this, this.state.isApp)}>
                                                <div data-icon-font="" className="icon"></div>
                                                <span className="ask-quen M14_white">UPLOAD YOUR RECIPE</span>
                                            </div>
                                        :
                                        <label htmlFor="upload_child">
                                            {this.state.isApp ?
                                                <div className="askquebtn choosephoto_App" onClick={() => { actions.appGallery("upload_child_recipe") }}>
                                                    <div data-icon-font="" className="icon"></div>
                                                    <span className="ask-quen M14_white" data-id="memory">CHOOSE YOUR PHOTO</span>
                                                </div> :
                                                <div className="askquebtn">
                                                    <div data-icon-font="" className="icon"></div>
                                                    <span className="ask-quen M14_white" data-id="memory">CHOOSE YOUR PHOTO</span>
                                                </div>
                                            }
                                        </label>
                                    }

                                </div>
                                {!this.state.isApp &&
                                    <input type="file" id="upload_child" style={{ display: 'none' }} onChange={(e) => actions.onChange(e, this, this.state.isApp)} />}
                                {/* <input type="file" id="upload_child" style="display: none;"> */}
                                <div>
                                    <UploadImgOverlay eleRef={this} tool={"recipeDetail"} />
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <input type="hidden" id="file_array" value="[]" />
                {/* <Right url={this.props.location.pathname} /> */}
            </main>
        )
    }
}

export default withContext(RecipeUpload);
